import React from 'react';
import { StethoscopeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 px-4 pb-28 pt-12 sm:px-6 sm:pb-32" data-id="element-142" data-mp="207t2iadmpnm3">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-143" data-mp="209nidaa1mpjb">
        <div className="flex items-center gap-2" data-id="element-144" data-mp="2f420z9pp3wxg">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/10 text-white" data-id="element-145" data-mp="2a57adllhl42s">
            <StethoscopeIcon className="h-5 w-5" aria-hidden="true" data-id="element-146" data-mp="1mfcx52x99di0" />
          </span>
          <span className="font-display text-lg font-bold text-white" data-id="element-147" data-mp="1hhbf8lbkfk84">
            GLP-1 Decision Map<sup className="text-[10px]" data-id="element-148" data-mp="1w5z9mo9odnwh">™</sup>
          </span>
        </div>

        <p className="mt-5 text-[13px] text-white/60" data-id="element-149" data-mp="1w8271td5qjb8">
          © 2026 · Dr. Karito – GLP-1 Decision Map™. All rights reserved.
        </p>
        <p className="mt-3 max-w-xl text-[12px] leading-relaxed text-white/45" data-id="element-150" data-mp="13p51f5vvxpbu">
          Educational material only. This product does not replace professional clinical judgment,
          current clinical guidelines, official medication information, or applicable regulations.
        </p>
      </div>
    </footer>;
}